const LABELS = {
    click : "Click",
    refreshCHart: "Refresh chart",

}
export default LABELS;